import { gql } from '@apollo/client';

//Queries
export const GET_USER_INFO_BY_USER_ID = gql`
  query getUserInfoByUserId($userId: String!) {
    userById(id: $userId) {
      fullName
      email
      phoneNumber
      address
      addressLine2
      city
      province
      postalCode
      country
    }
  }
`;

export const GET_STAFF_PROFILE = gql`
  query getStaffProfile {
    staffProfile {
      userId
      staffId
      staffCode
      fullName
      email
      phoneNumber
      roleName
      hasPIN
      hasPassword
      loginHistory {
        items {
          id
          ipAddress
          device
          createdAt
        }
        pageInfo {
          hasNextPage
          limit
          offset
          total
        }
      }
      notificationPreferences {
        id
        staffId
        notifyWhen
        minimumAlertLevel
        channels
      }
    }
  }
`;

export const GET_ALL_ROOMS = gql`
  query getAllRooms {
    validRooms {
      roomId: id
      roomNumber
      floor
      roomBookings {
        isCurrent
        booking {
          bookingId: id
          group {
            groupId: id
          }
          fullName
          status
          checkInDate
          checkOutDate
          checkedInAt
          checkedOutAt
        }
      }
      roomStatusHistories {
        roomStatusHistoryId: id
        status
        createdAt
        isCurrent
      }
      roomType {
        name
      }
    }
  }
`;

export const SUBSCRIBE_TO_ROOMS_UPDATED = gql`
  subscription subscribeToRoomsUpdated {
    roomMapUpdated {
      roomId: id
      roomNumber
      floor
      roomBookings {
        isCurrent
        booking {
          bookingId: id
          group {
            groupId: id
          }
          fullName
          status
          checkInDate
        }
      }
      roomStatusHistories {
        roomStatusHistoryId: id
        status
        createdAt
        isCurrent
      }
      roomType {
        name
      }
    }
  }
`;

export const GET_ALL_ROOM_TYPES = gql`
  query getAllRoomTypes {
    roomTypes {
      roomTypeId: id
      name
    }
  }
`;

export const GET_ALL_RATE_PLANS = gql`
  query getAllRatePlans {
    ratePlans {
      ratePlanId: id
      title
      rateChangeType
      rateChangeValue
      roomTypes {
        roomTypeRatePlanId: id
        roomType {
          roomTypeId: id
          name
          pricePerNight
        }
      }
      createdAt
    }
  }
`;

export const GET_ALL_HOTEL_CHARGES = gql`
  query getAllHotelCharges {
    hotelChargesSettings {
      earlyCheckin {
        enabled
        amount
      }
      lateCheckout {
        enabled
        amount
      }
      parking {
        enabled
        amount
      }
      breakfast {
        enabled
        amount
      }
      noShow {
        enabled
        amount
        useOneRoomNight
      }
      overstay {
        enabled
        amount
        useOneRoomNight
      }
    }
  }
`;

//FIXME: This query is not available yet, need to update the query once the backend is ready.
export const GET_ALL_HOTEL_INFOS = gql`
  query getAllHotelInfos {
    hotelInfos {
      id
    }
  }
`;

export const GET_ALL_COUPONS = gql`
  query getAllCoupons {
    coupons {
      couponId: id
      title
      couponCode
      discount
      rateType
      validFrom
      validTo
      isActive
    }
  }
`;

export const GET_ALL_DEVICES = gql`
  query getAllDevices {
    devices {
      deviceId: id
      name
      ipAddress
      port
      type
      isDeleted
    }
  }
`;

export const GET_ALL_KIOSKS = gql`
  query getAllKiosks {
    kiosks {
      kioskId: id
      username
      kioskNumber
      devices {
        device{
          deviceId: id
          name
          ipAddress
          port
          type
          isDeleted
        }
      }
      isAvailable
      isConnected
      isOperational
      isDeleted
    }
  }
`;

export const GET_ROOM_BY_ROOM_NUMBER = gql`
  query getRoomByRoomNumber($roomNumber: String!) {
    roomByNumber(roomNumber: $roomNumber) {
      roomId: id
      roomType {
        roomTypeId: id
        name
        hasWindows
        hasSkylight
        pricePerNight
      }
      roomBookings {
        isCurrent
        booking {
          bookingId: id
          email
          phoneNumber
          fullName
          group {
            groupId: id
          }
          checkInDate
          checkedInAt
          checkOutDate
          checkedOutAt
          isDeleted
        }
      }
      roomStatusHistories {
        roomStatusHistoryId: id
        status
        createdAt
      }
      roomNotes {
        noteId: id
        notes
        createdAt
        createdBy {
          fullName
        }
      }
    }
  }
`;

export const GET_ALERTS_BY_PAGESIZE_AND_PAGE_NUMBER = gql`
  query getAlertsByPageSizeAndPageNumber ($pageSize: Int!, $pageNumber: Int!, $showRead: Boolean, $orderBy: OrderByOptions) {
    allRoomAlerts(pageSize: $pageSize, pageNumber: $pageNumber, showRead: $showRead, orderBy: $orderBy) {
      alertId: id
      room {
        roomNumber
      }
      roomBooking {
        booking {
          group {
            groupId: id
          }
        }
      }
      priority
      description
      type
      originator
      createdAt
      isReadByCurrentUser
    }
  }
`;

export const SUBSCRIBE_TO_ALERT_ADDED = gql`
  subscription subscribeToAlertAdded {
    roomAlertAdded {
      alertId: id
      room {
        roomNumber
      }
      roomBooking {
        booking {
          group {
            groupId: id
          }
        }
      }
      priority
      description
      type
      originator
      createdAt
      isReadByCurrentUser
    }
  }
`;

export const GET_MESSAGES_BY_PAGESIZE_AND_PAGE_NUMBER = gql`
  query getMessagesByPageSizeAndPageNumber($input: LatestMessagesInput) {
    latestIncomingMessages(input: $input) {
      items {
        messageId: id
        conversationId
        sender {
          type
          userId
          name
          contactValue
        }
        channel
        direction
        status
        subject
        body
        createdAt
        isDeleted
      }
      pageInfo {
        limit
        offset
        total
        hasNextPage
      }
    }
  }
`;

export const SUBSCRIBE_TO_MESSAGE_ADDED = gql`
  subscription LatestInboundMessagesUpdated {
    latestInboundMessagesUpdated {
      type
      message {
        messageId: id
        conversationId
        sender {
          type
          userId
          name
          contactValue
        }
        channel
        direction
        status
        subject
        body
        createdAt
        isDeleted
      }
    }
  }
`;

export const GET_ALL_ROOM_NOTES = gql`
  query getAllRoomNotes {
    roomNotes {
      noteId: id
      notes
      createdAt
      isRead
      room {
        roomId: id
        roomNumber
      }
      createdBy {
        createdById: id
        fullName
      }
    }
  }
`;

export const GET_ALL_STAFFS = gql`
  query getAllStaffs {
    validStaff {
      staffId: id
      staffCode
      isActive
      user {
        fullName
        email
        phoneNumber
        createdAt
      }
      roles {
        roleId: id
        name
        code
      }
    }
  }
`;

export const GET_STAFF_INFO_BY_STAFF_ID = gql`
  query getStaffInfoByStaffId($staffId: String!) {
    staffByID(id: $staffId) {
      staffId: id
      isActive
      createdAt
      isDeleted
      setupCompletedAt
      user {
        userId: id
        fullName
        email
        phoneNumber
        address
        addressLine2
        city
        province
        postalCode
        country
      }
      roles {
        roleId: id
        name
        code
      }
      staffNotes {
        noteId: id
        notes
        createdAt
        createdBy {
          fullName
        }
      }
    }
  }
`;

export const GET_ALL_VALID_BOOKINGS = gql`
  query getAllValidBookings(
    $filters: BookingFiltersInput
    $orderBy: OrderByOptions
    $pagination: PaginationInput
  ) {
    validBookingsPaginated(filters: $filters, orderBy: $orderBy, pagination: $pagination) {
      items {
        bookingId: id
        email
        phoneNumber
        fullName
        reservationCode
        group {
          groupId: id
          name
          status
        }
        status
        checkInDate
        checkedInAt
        checkOutDate
        checkedOutAt
        roomBookings {
          room{
            roomNumber
          }
        }
      }
      pageInfo {
        limit
        offset
        total
        hasNextPage
      }
    }
  }
`;

export const GET_ALL_AVAILABLE_KIOSKS = gql`
  query getAllAvailableKiosks {
    availableKiosks {
      kioskId: id
      username
    }
  }
`;

export const GET_ALL_AVAILABLE_DEVICES = gql`
  query getAllAvailableDevices {
    devices {
      deviceId: id
      name
      ipAddress
      port
      type
      isDeleted
    }
  }
`;

export const GET_PAYMENT_TERMINAL_REQUEST_BY_ID = gql`
  query getPaymentTerminalRequestById($id: String!) {
    getPaymentTerminalRequestByID(id: $id) {
      id
      status
    }
  }
`

export const GET_BOOKING_DETAILS_BY_BOOKING_ID = gql`
  query getBookingDetailsByBookingId($bookingId: String!) {
    bookingByID(id: $bookingId) {
      bookingId: id
      email
      fullName
      phoneNumber
      tenantGroup {
        tenant {
          tenantId: id
          user {
            userId: id
            address
            addressLine2
            city
            province
            postalCode
            country
            dateOfBirth
          }
        }
      }
      reservationCode
      checkInDate
      checkedInAt
      checkOutDate
      checkedOutAt
      status
      isDeleted
      createdAt
      roomBookings {
        pricePerNight
        room {
          roomId: id
          roomNumber
          barrierFree
          roomType {
            roomTypeId: id
            name
            capacity
            hasWindows
            hasSkylight
            pricePerNight
          }
          roomStatusHistories {
            roomStatusHistoryId: id
            status
            createdAt
            isCurrent
          }
          roomNotes {
            noteId: id
            notes
            createdAt
            createdBy {
              createdById: id
              fullName
            }
          }
        }
      }
      group {
        groupId: id
        code
        primaryBookingCode
        status
        name
        bookings {
          bookingId: id
          status
          roomBookings {
            room {
              roomNumber
            }
          }
        }
        ratePlan {
          ratePlanId: id
          ratePlan {
            title
          }
        }
      }
      tenantGroup {
        tenant {
          tenantId: id
          user {
            userId: id
            dateOfBirth
          }
        }
      }
      bookingNotes {
        noteId: id
        notes
        createdAt
        createdBy {
          fullName
        }
      }
      addons {
        addonId: id
        bookingAddOn {
          bookingAddOnId: id
        }
        quantity
      }
    }
  }
`;

export const GET_GROUP_DETAILS_BY_GROUP_ID = gql`
  query getGroupDetailsByGroupId($groupId: String!) {
    groupByID(id: $groupId) {
      groupId: id
      name
      primaryBookingCode
      status
      numberOfGuests
      createdAt
      cancelledAt
      cancelledBy {
        fullName
      }
      cancellationReason
      cancellationFee
      origin
      channel
      otaBookingNumber
      fullName
      organization
      email
      phoneNumber
      streetAddress
      streetAddressLine2
      city
      province
      postalCode
      country
      isFirstNations
      subscribedToMarketingEmails
      subscribedToMarketingTexts
      tenants {
        tenant {
          tenantId: id
          user {
            userId: id
          }
        }
      }
      groupNotes {
        noteId: id
        notes
        createdAt
        createdBy {
          fullName
        }
      }
      bills {
        billId: id
        description
        subTotal
        MAT
        HST
        total
        ratePlanAmount
        depositSubTotal
        depositHSTAmount
        discountAmount
        addonPrice
        depositMATAmount
        depositRatePlanAmount
        depositAmountToPay
        securityDeposit
        depositTotal
        balance
        alreadyPaid
        status
        charges {
          chargeId:  id
          billId
          groupId
          bookingId
          type
          category
          description
          quantity
          unitPrice
          amount
          chargeDate
          isRedeemable
          vouchersRedeemed
          lastRedeemedAt
          lastRedeemedBy
          applyHST
          applyMAT
          originator
          notes
          isDeleted
          deletedAt
          deletedBy
          createdAt
          updatedAt
          roomNumber
          isUnused
        }
        transactions {
          transactionId: id
          elavonTransactionType: field0001
          amount: field0002
          creditCardNumber: field1008
          status: field1004
          description
          type
          category
          purpose
          originator
          voidOriginator
          voidDescription
          isRetried
          isVoided
          isRefunded
          gateway
          createdAt
          updatedAt
        }
      }
      bookings {
        bookingId: id
        status
        email
        phoneNumber
        fullName
        createdAt
        checkInDate
        checkedInAt
        checkOutDate
        checkedOutAt
        isDeleted
        cancelledAt
        cancelledBy {
          fullName
        }
        cancellationReason
        cancellationFee
        reservationCode
        stayPrices {
          stayPriceId: id
          date
          pricePerNight
        }
        addons {
          addonId: id
          bookingAddOn {
            bookingAddOnId: id
            title
            label
            description
            pricePerNight
            isOneTimePriced
          }
          quantity
        }
        roomBookings {
          roomBookingId: id
          pricePerNight
          room {
            roomId: id
            roomNumber
            roomStatusHistories {
              roomStatusHistoryId: id
              status
              createdAt
              isCurrent
            }
            barrierFree
            roomType {
              roomTypeId: id
              name
              bed
              hasWindows
              hasSkylight
              capacity
            }
          }
        }
      }
      paymentCards {
        paymentCardId: id
        holderName
        streetAddress
        streetAddressLine2
        city
        province
        postalCode
        country
        transaction {
          transactionId: id
          amount: field0002
          creditCardNumber: field1008
          cardExpirationDate: field0004
        }
        isPrimary
      }
      identityScans {
        scanId: id
        statusChecks {
          overallPassed
          documentRecognized
          isExpired
          securityPassed
        }
        age
        fullName
        dateOfBirth
        address
        documentNumber
        documentType
        dateOfIssue
        dateOfExpiry
        issuingState
        nationality
      }
    }
  }
`;

export const GET_TENANT_INFO_BY_BOOKING_ID = gql`
  query getTenantInfoByBookingId($bookingId: String!) {
    bookingByID(id: $bookingId) {
      tenantGroup {
        group {
          groupId: id
        }
        tenant {
          tenantId: id
          user {
            userId: id
            fullName
            email
            phoneNumber
            address
            addressLine2
            city
            province
            postalCode
            country
            dateOfBirth
          }
        }
      }
    }
  }
`;

export const GET_TENANT_INFO_BY_TENANT_ID = gql`
  query getTenantInfoByTenantId($tenantId: String!) {
    tenantByID(id: $tenantId) {
      user {
        userId: id
        fullName
        email
        phoneNumber
        address
        addressLine2
        city
        province
        postalCode
        country
        dateOfBirth
      }
      tenantNotes {
        noteId: id
        notes
        createdAt
        createdBy {
          fullName
        }
      }
      groups {
        group {
          groupId: id
          bookings {
            bookingId: id
            checkOutDate
            checkInDate
            roomBookings {
              room {
                roomType {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_AVAILABLE_ROOMS_BY_ROOM_TYPE_ID_AND_DATE_RANGE = gql`
  query getAvailableRoomsByRoomTypeAndDateRange($input: RoomAvailabilityInput!) {
    roomsAvailability(data: $input) {
      roomId: id
      roomNumber
      roomStatusHistories {
        roomStatusHistoryId: id
        status
        createdAt
        isCurrent
      }
      roomType {
        name
      }
    }
  }
`;

export const GET_AVAILABLE_ROOM_TYPES_BY_DATE_RANGE = gql`
  query getAvailableRoomTypesByDateRange($input: RoomTypeByDateRangeInput!) {
    availableRoomTypesByDateRange(data: $input) {
      roomTypeId: id
      name
      bed
      hasWindows
      hasSkylight
      pricePerNight
      availableRooms
    }
  }
`;

export const GET_AVAILABLE_ROOMS_FOR_ROOM_CHANGE = gql`
  query getAvailableRoomsForRoomChange ($input: GetRoomChangeAvailabilityInput!) {
    availableRoomsForRoomChange(data: $input) {
      roomId: id
      roomNumber
      floor
      roomStatusHistories {
        roomStatusHistoryId: id
        status
        createdAt
        isCurrent
      }
      roomType {
        name
        pricePerNight
      }
    }
  }
`;

export const GET_RATE_PLAN_BY_RATE_PLAN_ID = gql`
  query getRatePlanByRatePlanId($ratePlanId: String!) {
    ratePlansCacheByRatePlanId(id: $ratePlanId) {
      discount
    }
  }
`;

export const GET_EVENT_HISTORY_BY_BOOKING_ID = gql`
  query getEventHistoryByBookingId($bookingId: String!) {
    eventHistoryByBookingID(bookingId: $bookingId) {      
      eventHistoryId: id
      event
      description
      createdAt
    }
  }
`;

export const GET_ALL_BOOKING_ADD_ONS = gql`
  query getAllBookingAddOns {
    validBookingAddons {
      bookingAddOnId: id
      title
      label
      description
      pricePerNight
      isOneTimePriced
    }
  }
`;

export const GET_EMAIL_SUBSCRIPTIONS_BY_USER_ID = gql`
  query getEmailSubscriptionsByUserId($userId: String!) {
    emailSubscriptionsByUser(userId: $userId) {
      subscriptionId: id
      isCancelled
      subscriptionType {
        subscriptionTypeId: id
      }
    }
  }
`;

export const GET_PHONE_SUBSCRIPTIONS_BY_USER_ID = gql`
  query getPhoneSubscriptionsByUserId($userId: String!) {
    phoneSubscriptionsByUser(userId: $userId) {
      subscriptionId: id
      isCancelled
      subscriptionType {
        subscriptionTypeId: id
      }
    }
  }
`;

export const GET_ALL_STAFF_ROLES = gql`
  query getAllStaffRoles {
    validStaffRoles {
      roleId: id
      name
      code
      description
      privileges {
        privilegeId: id
        name
        description
      }
    }
  }
`;

export const GET_DAILY_RECONCILIATION_REPORTS_BY_FILTER = gql`
  query getDailyReconciliationReportsByFilter($filter: DailyReconciliationFilterInput!) {
    dailyReconciliationReport(filter: $filter) {
      generatedAt
      rows {
        transactionId
        bookingId
        groupId
        bookingCode
        otaBookingCode
        transactionReferenceNumber
        chargeDatetime
        customerName
        numberOfRooms
        chargeType
        checkInDate
        checkOutDate
        bookingFee
        lodging
        subTotal
        misc
        mat
        hst
        totalCharged
      }
    }
  }
`;

export const GET_WIFI = gql`
  query getWifi($input: GetWiFiCredentialsInput!) {
    bookingWiFiCredentials(input: $input) {
      wifiId: id
      ssid
      password
    }
  }
`;

// Mutations
export const LOGIN = gql`
  mutation login($input: LoginInput!) {
    authenticate(data: $input) {
      accessToken
    }
  }
`;

export const UPDATE_USER_INFO_BY_USER_ID = gql`
  mutation updateUserInfoByUserId($userId: String!, $input: UpdateUserInput!) {
    updateUser(id: $userId, data: $input) {
      id
    }
  }
`;

export const MARK_ROOM_ALERT_AS_READ = gql`
  mutation markRoomAlertAsRead ($alertId: String!) {
    markRoomAlertAsRead(id: $alertId) 
  }
`;

export const MARK_ROOM_ALERT_AS_UNREAD = gql`
  mutation markRoomAlertAsUnread ($alertId: String!) {
    markRoomAlertAsUnread(id: $alertId) 
  }
`;

export const MARK_ALL_ROOM_ALERTS_AS_READ = gql`
  mutation markAllRoomAlertsAsRead {
    markAllRoomAlertsAsRead 
  }
`;

export const MARK_MESSAGE_AS_READ = gql`
  mutation MarkMessageAsRead($input: MessageIdInput!) {
    markMessageAsRead(input: $input) {
      id
      status
      createdAt
    }
  }
`;

export const MARK_MESSAGE_AS_UNREAD = gql`
  mutation MarkMessageAsUnread($input: MessageIdInput!) {
    markMessageAsUnread(input: $input) {
      id
      status
      createdAt
    }
  }
`;

export const MARK_ALL_INCOMING_MESSAGES_AS_READ = gql`
  mutation markAllIncomingMessagesAsRead {
    markAllIncomingMessagesAsRead {
      id
    } 
  }
`;

export const UPDATE_ROOM_STATUS = gql`
  mutation updateRoomStatus ($input: CreateRoomStatusHistoryInput!) {
    createRoomStatusHistory(data: $input) {
      id
    }
  }
`;

export const CREATE_ROOM_NOTE = gql`
  mutation createRoomNote($input: CreateRoomNoteInput!) {
    createRoomNote(data: $input) {
      id
    }
  }
`;

export const UPDATE_ROOM_NOTE_BY_ROOM_NOTE_ID = gql`
  mutation updateRoomNoteByRoomNoteId($noteId: String!,$input: CreateRoomNoteInput!) {
    updateRoomNote(id: $noteId, data: $input) {
      id
    }
  }
`;

export const DELETE_ROOM_NOTE_BY_ROOM_NOTE_ID = gql`
  mutation deleteRoomNoteByRoomNoteId($noteId: String!) {
    deleteRoomNote(id: $noteId) {
      id
    }
  }
`;

export const CREATE_BOOKING_NOTE = gql`
  mutation createBookingNote($input: CreateBookingNoteInput!) {
    createBookingNote(data: $input) {
      id
    }
  }
`;

export const DELETE_BOOKING_NOTE_BY_BOOKING_NOTE_ID = gql`
  mutation deleteBookingNoteByBookingNoteId($noteId: String!) {
    deleteBookingNote(id: $noteId) {
      id
    }
  }
`;

export const CREATE_GROUP_NOTE = gql`
  mutation createGroupNote($input: CreateGroupNoteInput!) {
    createGroupNote(data: $input) {
      id
    }
  }
`;

export const DELETE_GROUP_NOTE_BY_GROUP_NOTE_ID = gql`
  mutation deleteGroupNoteByGroupNoteId($noteId: String!) {
    deleteGroupNote(id: $noteId) {
      id
    }
  }
`;

export const CREATE_TENANT_NOTE = gql`
  mutation createTenantNote($input: CreateTenantNoteInput!) {
    createTenantNote(data: $input) {
      id
    }
  }
`;

export const DELETE_TENANT_NOTE_BY_TENANT_NOTE_ID = gql`
  mutation deleteTenantNoteByTenantNoteId($noteId: String!) {
    deleteTenantNote(id: $noteId) {
      id
    }
  }
`;

export const CREATE_STAFF_NOTE = gql`
  mutation createStaffNote($input: CreateStaffNoteInput!) {
    createStaffNote(data: $input) {
      id
    }
  }
`;

export const DELETE_STAFF_NOTE_BY_STAFF_NOTE_ID = gql`
  mutation deleteStaffNoteByStaffNotesId($noteId: String!) {
    deleteStaffNote(id: $noteId) {
      id
    }
  }
`;

export const UPDATE_BOOKING_ROOM_BY_BOOKING_ID_AND_ROOM_ID = gql`
  mutation updateBookingRoomByRoomIdAndBookingId($input: IsRoomAvailableInput!) {
    updateRoomBooking(data: $input) {
      id
    }
  }
`;

export const CREATE_GROUP_BOOKING = gql`
  mutation createGroupBooking($input: GroupTenantBookingInput!) {
    createGroupBooking(data: $input) {
      bookings {
        group {
          groupId: id
        }
      }
    }
  }
`;

export const MAKE_PAYMENT_BY_GROUP_ID = gql`
  mutation makePaymentByGroupId($input: MakePaymentAtTerminalInput!) {
    makePayment(data: $input) {
      makePaymentId: id
      transaction {
        transactionId: id
        refId
      }
    }
  }
`;

export const DELETE_BOOKING_BY_BOOKING_ID = gql`
  mutation deleteBookingByBookingId($bookingId: String!, $input: DeleteBookingInput!) {
    deleteBooking(id: $bookingId, data: $input) {
      status
    }
  }
`;

export const DELETE_GROUP_BY_GROUP_ID = gql`
  mutation deleteGroupByGroupId($groupId: String!, $input: DeleteBookingInput!) {
    deleteGroup(id: $groupId, data: $input) {
      isDeleted
    }
  }
`;

export const UPDATE_BOOKING_BY_BOOKING_ID = gql`
  mutation updateBookingByBookingId($bookingId: String!, $input: UpdateBookingInput!) {
    updateBooking(id: $bookingId, data: $input) {
      id
    }
  }
`;

export const UPDATE_GROUP_BY_GROUP_ID = gql`
  mutation updateGroupByGroupId($groupId: String!, $input: UpdateGroupInput!) {
    updateGroup(id: $groupId, data: $input) {
      groupId: id
      bills {
        billId: id
        description
        subTotal
        MAT
        HST
        total
        ratePlanAmount
        depositSubTotal
        depositHSTAmount
        discountAmount
        addonPrice
        depositMATAmount
        depositRatePlanAmount
        depositAmountToPay
        securityDeposit
        depositTotal
        balance
        alreadyPaid
        status
        charges {
          chargeId:  id
          billId
          groupId
          bookingId
          type
          category
          description
          quantity
          unitPrice
          amount
          chargeDate
          isRedeemable
          vouchersRedeemed
          lastRedeemedAt
          lastRedeemedBy
          applyHST
          applyMAT
          originator
          notes
          isDeleted
          deletedAt
          deletedBy
          createdAt
          updatedAt
          roomNumber
          isUnused
        }
        transactions {
          transactionId: id
          elavonTransactionType: field0001
          amount: field0002
          creditCardNumber: field1008
          status: field1004
          description
          type
          category
          purpose
          originator
          voidOriginator
          voidDescription
          isRetried
          isVoided
          isRefunded
          gateway
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const CREATE_BOOKING_CHECK_IN = gql`
  mutation createBookingCheckIn($input: CreateBookingCheckInInput!) {
    createBookingCheckIn(data: $input) {
      id
    }
  }
`;

export const CREATE_BOOKING_CHECK_IN_WITHOUT_CARD_SWIPE = gql`
  mutation createBookingCheckInWithoutCardSwipe($input: CheckInWithoutCardSwipeInput!) {
    checkInWithoutCardSwipe(data: $input) {
      id
    }
  }
`;

export const CREATE_BOOKING_CHECK_OUT = gql`
  mutation createBookingCheckOut($input: CreateMultipleBookingIDCheckInInput!) {
    createMultipleBookingIDCheckout(data: $input) {
      id
    }
  }
`;

export const CREATE_PAYMENT_CARD = gql`
  mutation createPaymentCard($input: CreatePaymentCard!) {
    createPaymentCard(data: $input) {
      paymentCardId: id
      holderName
      streetAddress
      streetAddressLine2
      city
      province
      postalCode
      country
      transaction {
        transactionId: id
        amount: field0002
        creditCardNumber: field1008
        cardExpirationDate: field0004
      }
      isPrimary
    }
  }
`;

export const DELETE_CREDIT_CARD = gql`
  mutation deleteCreditCard($paymentCardId: String!) {
    removePaymentCard(id: $paymentCardId) {
      id
    }
  }
`;

export const SET_CREDIT_CARD_PRIMARY = gql`
  mutation setCreditCardPrimary($input: SetPrimaryPaymentCard!) {
    setPrimaryPaymentCard(data: $input) {
      id
    }
  }
`;

export const SUBSCRIBE_BOOKING_ADD_ONS = gql`
  mutation subscribeBookingAddOns($input: SubscribeToAddonInput!) {
    subscribeBookingAddons(data: $input) {
      id
    }
  }
`;

export const CREATE_REFUND = gql`
  mutation createRefund($input: RefundTransactionInput!) {
    makeRefund(data: $input) {
      transactionId: id
      elavonTransactionType: field0001
      amount: field0002
      creditCardNumber: field1008
      status: field1004
      description
      type
      category
      purpose
      originator
      voidOriginator
      voidDescription
      isRetried
      isVoided
      isRefunded
      gateway
      createdAt
      updatedAt
    }
  }
`;

export const VOID_TRANSACTION = gql`
  mutation voidTransaction($input: TransactionEndpointInput!) {
    voidTransaction(data: $input) {
      transactionId: id
      elavonTransactionType: field0001
      amount: field0002
      creditCardNumber: field1008
      status: field1004
      description
      type
      category
      purpose
      originator
      voidOriginator
      voidDescription
      isRetried
      isVoided
      isRefunded
      gateway
      createdAt
      updatedAt
    }
  }
`;

export const RETRY_TRANSACTION = gql`
  mutation retryTransaction($input: TransactionEndpointInput!) {
    retryTransaction(data: $input) {
      transactionId: id
      elavonTransactionType: field0001
      amount: field0002
      creditCardNumber: field1008
      status: field1004
      description
      type
      category
      purpose
      originator
      voidOriginator
      voidDescription
      isRetried
      isVoided
      isRefunded
      gateway
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_PAYMENT = gql`
  mutation createPayment($input: MakePaymentAtTerminalInput!) {
    makePayment(data: $input) {
      id
    }
  }
`;

export const ADD_BOOKING_TO_GROUP = gql`
  mutation addBookingToGroup($groupId: String!, $input: AddRoomToBookingInput!) {
    addBookingToGroup(groupId: $groupId, data: $input) {
      id
    }
  }
`;

export const UPDATE_TENANT_INFO_BY_TENANT_ID = gql`
  mutation updateTenantInfoByTenantId($tenantId: String!, $input: UpdateTenantByTenantIdInput!) {
    updateTenant(id: $tenantId, data: $input) {
      id
    }
  }
`;

export const UPDATE_STAFF_INFO_BY_STAFF_ID = gql`
  mutation updateStaffInfoByStaffId($staffId: String!, $input: UpdateStaffInput!) {
    updateStaff(id: $staffId, data: $input) {
      id
    }
  }
`;

export const UPDATE_STAFF_NOTIFICATION_PREFERENCES = gql`
  mutation updateStaffNotificationPreferences($input: UpdateStaffNotificationPreferenceInput!) {
    updateStaffNotificationPreferences(data: $input) {
      id
    }
  }
`;

export const DELETE_STAFF_BY_STAFF_ID = gql`
  mutation deleteStaffByStaffId($staffId: String!) {
    deleteStaff(id: $staffId) {
      id
    }
  }
`;

export const DELETE_TENANT_BY_TENANT_ID = gql`
  mutation deleteTenantByTenantId($tenantId: String!) {
    deleteTenant(id: $tenantId) {
      id
    }
  }
`;

export const CREATE_CHARGE = gql`
  mutation createCharge($input: CreateBillChargeInput!) {
    createCharge(data: $input) {
      billId: id
      description
      subTotal
      MAT
      HST
      total
      ratePlanAmount
      depositSubTotal
      depositHSTAmount
      discountAmount
      addonPrice
      depositMATAmount
      depositRatePlanAmount
      depositAmountToPay
      securityDeposit
      depositTotal
      balance
      alreadyPaid
      status
      charges {
        chargeId:  id
        billId
        groupId
        bookingId
        type
        category
        description
        quantity
        unitPrice
        amount
        chargeDate
        isRedeemable
        vouchersRedeemed
        lastRedeemedAt
        lastRedeemedBy
        applyHST
        applyMAT
        originator
        notes
        isDeleted
        deletedAt
        deletedBy
        createdAt
        updatedAt
        roomNumber
        isUnused
      }
      transactions {
        transactionId: id
        elavonTransactionType: field0001
        amount: field0002
        creditCardNumber: field1008
        status: field1004
        description
        type
        category
        purpose
        originator
        voidOriginator
        voidDescription
        isRetried
        isVoided
        isRefunded
        gateway
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_CHARGE = gql`
  mutation deleteCharge($input: DeleteChargeInput!) {
    deleteCharge(data: $input) {
      billId: id
      description
      subTotal
      MAT
      HST
      total
      ratePlanAmount
      depositSubTotal
      depositHSTAmount
      discountAmount
      addonPrice
      depositMATAmount
      depositRatePlanAmount
      depositAmountToPay
      securityDeposit
      depositTotal
      balance
      alreadyPaid
      status
      charges {
        chargeId:  id
        billId
        groupId
        bookingId
        type
        category
        description
        quantity
        unitPrice
        amount
        chargeDate
        isRedeemable
        vouchersRedeemed
        lastRedeemedAt
        lastRedeemedBy
        applyHST
        applyMAT
        originator
        notes
        isDeleted
        deletedAt
        deletedBy
        createdAt
        updatedAt
        roomNumber
        isUnused
      }
      transactions {
        transactionId: id
        elavonTransactionType: field0001
        amount: field0002
        creditCardNumber: field1008
        status: field1004
        description
        type
        category
        purpose
        originator
        voidOriginator
        voidDescription
        isRetried
        isVoided
        isRefunded
        gateway
        createdAt
        updatedAt
      }
    }
  }
`;

export const RESTORE_CHARGE = gql`
  mutation restoreCharge($chargeId: ID!) {
    restoreCharge(chargeId: $chargeId) {
      billId: id
      description
      subTotal
      MAT
      HST
      total
      ratePlanAmount
      depositSubTotal
      depositHSTAmount
      discountAmount
      addonPrice
      depositMATAmount
      depositRatePlanAmount
      depositAmountToPay
      securityDeposit
      depositTotal
      balance
      alreadyPaid
      status
      charges {
        chargeId:  id
        billId
        groupId
        bookingId
        type
        category
        description
        quantity
        unitPrice
        amount
        chargeDate
        isRedeemable
        vouchersRedeemed
        lastRedeemedAt
        lastRedeemedBy
        applyHST
        applyMAT
        originator
        notes
        isDeleted
        deletedAt
        deletedBy
        createdAt
        updatedAt
        roomNumber
        isUnused
      }
      transactions {
        transactionId: id
        elavonTransactionType: field0001
        amount: field0002
        creditCardNumber: field1008
        status: field1004
        description
        type
        category
        purpose
        originator
        voidOriginator
        voidDescription
        isRetried
        isVoided
        isRefunded
        gateway
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_CHARGE = gql`
  mutation updateCharge($input: UpdateChargeInput!) {
    updateCharge(data: $input) {
      billId: id
      description
      subTotal
      MAT
      HST
      total
      ratePlanAmount
      depositSubTotal
      depositHSTAmount
      discountAmount
      addonPrice
      depositMATAmount
      depositRatePlanAmount
      depositAmountToPay
      securityDeposit
      depositTotal
      balance
      alreadyPaid
      status
      charges {
        chargeId:  id
        billId
        groupId
        bookingId
        type
        category
        description
        quantity
        unitPrice
        amount
        chargeDate
        isRedeemable
        vouchersRedeemed
        lastRedeemedAt
        lastRedeemedBy
        applyHST
        applyMAT
        originator
        notes
        isDeleted
        deletedAt
        deletedBy
        createdAt
        updatedAt
        roomNumber
        isUnused
      }
      transactions {
        transactionId: id
        elavonTransactionType: field0001
        amount: field0002
        creditCardNumber: field1008
        status: field1004
        description
        type
        category
        purpose
        originator
        voidOriginator
        voidDescription
        isRetried
        isVoided
        isRefunded
        gateway
        createdAt
        updatedAt
      }
    }
  }
`;

export const SETTLE_PAYMENT = gql`
  mutation settlePayment($groupId: String!) {
    priorAuthorizedSale(groupId: $groupId) {
      id
    }
  } 
`;

export const APPLY_COUPON_TO_GROUP = gql`
  mutation applyCouponToGroup($input: ApplyCouponInput!) {
    applyCoupon(data: $input) {
      groupId: id
      bills {
        billId: id
        description
        subTotal
        MAT
        HST
        total
        ratePlanAmount
        depositSubTotal
        depositHSTAmount
        discountAmount
        addonPrice
        depositMATAmount
        depositRatePlanAmount
        depositAmountToPay
        securityDeposit
        depositTotal
        balance
        alreadyPaid
        status
        charges {
          chargeId:  id
          billId
          groupId
          bookingId
          type
          category
          description
          quantity
          unitPrice
          amount
          chargeDate
          isRedeemable
          vouchersRedeemed
          lastRedeemedAt
          lastRedeemedBy
          applyHST
          applyMAT
          originator
          notes
          isDeleted
          deletedAt
          deletedBy
          createdAt
          updatedAt
          roomNumber
          isUnused
        }
        transactions {
          transactionId: id
          elavonTransactionType: field0001
          amount: field0002
          creditCardNumber: field1008
          status: field1004
          description
          type
          category
          purpose
          originator
          voidOriginator
          voidDescription
          isRetried
          isVoided
          isRefunded
          gateway
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const CREATE_EMAIL_SUBSCRIPTION = gql`
  mutation createEmailSubscription($input: CreateSubscriptionInput!) {
    createEmailSubscription(data: $input) {
      subscriptionId: id
    }
  }
`;

export const DELETE_EMAIL_SUBSCRIPTION = gql`
  mutation deleteEmailSubscription($subscriptionId: String!) {
    emailUnsubscription(id: $subscriptionId) 
  }
`;

export const CREATE_PHONE_SUBSCRIPTION = gql`
  mutation createPhoneSubscription($input: CreateSubscriptionInput!) {
    createPhoneSubscription(data: $input) {
      subscriptionId: id
    }
  }
`;

export const DELETE_PHONE_SUBSCRIPTION = gql`
  mutation deletePhoneSubscription($subscriptionId: String!) {
    phoneUnsubscription(id: $subscriptionId)
  }
`;

export const UPDATE_STAFF_PIN = gql`
  mutation updateStaffPIN($staffId: String!, $input: UpdateStaffPinInput!) {
    updateStaffPin(id: $staffId, data: $input) {
      id
    }
  }
`;

export const VALIDATE_STAFF_PIN = gql`
  query validateStaffPIN($pin: String!) {
    validateStaffPin(pin: $pin) {
      staffId
    }
  }
`;

export const STAFF_CONTACT_CHANGE_SEND_CURRENT_OTP = gql`
  mutation staffContactChangeSendCurrentOtp($input: UserPrimaryContactType!) {
    staffContactChangeSendCurrentOtp(contactType: $input) 
  }
`;


export const VERIFY_CURRENT_ACCOUNT = gql`
  mutation verifyCurrentAccount($input: StaffContactChangeConfirmCurrentInput!) {
    staffContactChangeConfirmCurrentOtp(data: $input) 
  }
`;

export const CHANGE_CONTACT = gql`
  mutation changeContact($input: StaffContactChangeNewDestinationInput!) {
    staffContactChangeSendNewOtp(data: $input)
  }
`;

export const VERIFY_NEW_CONTACT = gql`
  mutation verifyNewContact($input: StaffContactChangeCompleteInput!) {
    staffContactChangeComplete(data: $input)
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($input: ForgotPasswordStaffInput!) {
    forgotPasswordStaff(data: $input)
  }
`;

export const RESET_PASSWORD_STAFF = gql`
  mutation resetPasswordStaff($input: ResetPasswordInput!) {
    resetPasswordStaff(data: $input) {
      userId: id
    }
  }
`;

export const CREATE_STAFF = gql`
  mutation createStaff($input: CreateStaffInput!) {
    createStaff(data: $input) {
      staffId: id
      isActive
      user {
        fullName
        email
        phoneNumber
        createdAt
      }
      roles {
        roleId: id
        name
        code
      }
    }
  }
`;

export const CONFIRM_STAFF_SETUP_EMAIL = gql`
  mutation confirmStaffSetupEmail($input: StaffSetupConfirmEmailInput!) {
    confirmStaffSetupEmail(data: $input) {
      sessionToken
    }
  }
`;

export const RESEND_STAFF_ACTIVATION_INVITATION = gql`
  mutation resendStaffActivationInvitation($staffId: String!) {
    resendStaffActivationInvitation(staffId: $staffId) {
      staffId: id
    }
  }
`;

export const SEND_STAFF_SETUP_PHONE_CODE = gql`
  mutation sendStaffSetupPhoneCode($input: StaffSetupSendPhoneCodeInput!) {
    sendStaffSetupPhoneCode(data: $input) {
      maskedPhone
    }
  }
`;

export const VERIFY_STAFF_SETUP_PHONE = gql`
  mutation verifyStaffSetupPhone($input: StaffSetupVerifyPhoneInput!) {
    verifyStaffSetupPhone(data: $input)
  }
`;

export const COMPLETE_STAFF_SETUP = gql`
  mutation completeStaffSetup($input: StaffSetupSetPasswordInput!) {
    completeStaffSetup(data: $input)
  }
`;

export const GLOBAL_SEARCH = gql`
  query search($input: GlobalSearchInput!) {
    globalSearch(data: $input) {
      entityType
      moreResults
      items {
        type
        id
        data
        relatedEntities {
          entityType
          id
        }
      }
    }
  }
`;

export const PASSPORT_SCAN = gql`
  mutation passportScan($input: ScanOptionsInput!) {
    scan(options: $input) {
      scanId: id
      groupId
      overallStatus
      statusChecks {
        overallPassed
        documentRecognized
        securityPassed
        isExpired
      }
      statusCode
      statusMessage
      isRecognized
      fullName
      surname
      givenNames
      dateOfBirth
      age
      placeOfBirth
      nationality
      nationalityCode
      address
      personalNumber
      documentNumber
      documentType
      dateOfIssue
      dateOfExpiry
      issuingState
      issuingStateCode
      sex
    }
  }
`;

export const CREATE_IDENTITY_SCAN = gql`
  mutation createIdentityScan($input: CreateIdentityScanInput!) {
    createIdentityScan(input: $input) {
      scanId: id
    }
  }
`;

export const UPDATE_IDENTITY_SCAN = gql`
  mutation updateIdentityScan($input: UpdateIdentityScanInput!) {
    updateIdentityScan(input: $input) {
      scanId: id
    }
  }
`;

export const RESET_WIFI = gql`
  mutation restWifi($input: RegenerateRoomBookingWiFiCredentialsInput!) {
    regenerateRoomBookingWiFiCredentials(input: $input) {
      wifiId: id
      ssid
      password
    }
  }
`;

export const INVALIDATE_WIFI = gql`
  mutation invalidateWifi($input: InvalidateBookingWiFiCredentialsInput!) {
    invalidateBookingWiFiCredentials(input: $input) 
  }
`;

//FIXME: The following APIs do not working properly
export const ACTIVATE_RATE_PLAN = gql`
  mutation activateRatePlan($ratePlanId: String!) {
    activateRatePlan(id: $ratePlanId) {
      id
    }
  }
`;

//FIXME: The following APIs do not working properly
export const DEACTIVATE_RATE_PLAN = gql`
  mutation deactivateRatePlan($ratePlanId: String!) {
    deactivateRatePlan(id: $ratePlanId) {
      id
    }
  }
`;

//FIXME: The following APIs do not working properly
export const CREATE_RATE_PLAN = gql`
  mutation createRatePlan($input: CreateBillOfSaleInput!) {
    createCharge(data: $input) {
      id
    }
  }
`;

export const CREATE_DEVICE = gql`
  mutation createDevice($input: CreateDeviceInput!) {
    createDevice(data: $input) {
      deviceId: id
      name
      type
      port
      ipAddress
      isDeleted
    }
  }
`;

export const CREATE_KIOSK = gql`
  mutation createKiosk($input: CreateKioskInput!) {
    createKiosk(data: $input) {
      kioskId: id
      username
      kioskNumber
      devices {
        device{
          deviceId: id
          name
          ipAddress
          port
          type
          isDeleted
        }
      }
      isAvailable
      isConnected
      isOperational
      isDeleted
    }
  }
`;

//FIXME: The following APIs do not working properly
export const ACTIVATE_COUPON = gql`
  mutation activateCoupon($couponId: String!) {
    activateCoupon(id: $couponId) {
      id
    }
  }
`;

//FIXME: The following APIs do not working properly
export const DEACTIVATE_COUPON = gql`
  mutation deactivateCoupon($couponId: String!) {
    deactivateCoupon(id: $couponId) {
      id
    }
  }
`;

//FIXME: The following APIs do not working properly
export const ACTIVATE_KIOSK = gql`
  mutation activateKiosk($kioskId: String!) {
    activateKiosk(id: $kioskId) {
      id
    }
  }
`;

//FIXME: The following APIs do not working properly
export const DEACTIVATE_KIOSK = gql`
  mutation deactivateKiosk($kioskId: String!) {
    deactivateKiosk(id: $kioskId) {
      id
    }
  }
`;

//FIXME: The following APIs do not working properly
export const UNLOCK_DOOR = gql`
  mutation unlockDoor($roomNumber: String!) {
    unlockDoor(roomNumber: $roomNumber) {
      id
    }
  }
`;

//FIXME: The following APIs do not working properly
export const INVALIDATE_KEY = gql`
  mutation invalidateKey($roomNumber: String!) {
    invalidateKey(roomNumber: $roomNumber) {
      id
    }
  }
`;

//FIXME: The following APIs do not working properly
export const GENERATE_KEY = gql`
  mutation generateKey($input: GenerateKeyInput!) {
    generateKey(data: $input) {
      id
    }
  }
`;

//FIXME: The following APIs do not working properly
export const DOWNLOAD_RECEIPT = gql`
  mutation downloadReceipt($input: DownloadReceiptInput!) {
    downloadReceipt(data: $input)
  }
`;